import React from "react";
import "./style.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "components/Button/Button";
import CoverPhoto from "pages/City/CityInfo/CoverPhoto";
import SocialMedia from "pages/City/CityInfo/SocialMedia";
// import CityAdmin from "pages/City/CityInfo/CityAdmin";
import CityImage from "Assets/present-img.png";
//import avatar from "Assets/avatarnew.svg";
//import { apiUrl, myHeaders_Autorized, HeaderConfig, location_api, myHeaders_With_Cache_Control,search_Presentation_API } from "Api/Api";
import { apiUrl, myHeaders_Autorized, HeaderConfig, location_api, myHeaders_With_Cache_Control } from "Api/Api";
import axios from 'axios';
import { NavLink } from "react-router-dom";
import { local_routes } from 'utils/Routes';
//import {get_current_unix_stamp, current_unix_stamp} from 'utils/Helper';
import { get_current_unix_stamp } from 'utils/Helper';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import MultipleImagesUpload from 'components/MultipleImagesUpload/MultipleImagesUpload';
import Select from 'react-select';
//import { fi } from "date-fns/locale";
import ShareAccessModalButton from '../../../components/Modals/ShareAccessModalButton'

const max_additional_images = 8;

/*
let adminDetails = [
  {
    id: 1,
    Image: avatar,
    adminName: "Sean Smyth",
    adminEmail: "sean@pechakucha.org",
    removeBtn: true
  },
  {
    id: 2,
    Image: avatar,
    adminName: "John Brooks",
    adminEmail: "john@pechakucha.org",
    removeBtn: false
  }
];
*/

let friendly_url = '';

class CityInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      volume_count: 0,
      cityDescription: '',
      cityEntityId: null,
      cityImg: null,
      loading: true,
      isLoader: false,
      updateCityLoader: false,
      receivedImg: null,
      twitter: '',
      facebook: '',
      instagram: '',
      cityAdminData: [],
      multipleImages: [],
      multipleImagesArr: [],
      savedMultiImages: [],
      //imageValidator: false,
      location_uuid: null,
      presentationDataArr:[],
      selectedOption:null,
      selectedData:null,
      addionalPatchImages:[],
      multiImages:[]
    };
		this.locationInfo = {}
  }



  componentDidMount() {
    this.setState({ loading: true })
    const { match: { params: { friendly_url } = {} } = {} } = this.props;
    Promise.all([
      axios.get(`${apiUrl}locations/${friendly_url}`, myHeaders_With_Cache_Control)
    ])
      .then(([cityDataApiRes]) => {
        Promise.all([
          axios.get(`${apiUrl}locations/${cityDataApiRes.data.entity_uuid}/users`, HeaderConfig),
          //axios.get(`${apiUrl}locations/${cityDataApiRes.data.entity_uuid}/presentations?sort[spotlighted_time]=desc`,myHeaders_With_Cache_Control)
          axios.get(`${apiUrl}locations/${cityDataApiRes.data.entity_uuid}/presentations?sort_obj=${encodeURIComponent('{"spotlighted_time":"desc"}')}`,myHeaders_With_Cache_Control)
        ])
          .then(([cityUserDataApiRes,presentationDataApiRes]) => {
            let presentationData=presentationDataApiRes.data;
            let presentationTempArr=[];let selectedTempArr=[];
            if (cityUserDataApiRes.data) {
              let cityAdminTempArr = []; let cityAdminApiRes = cityUserDataApiRes.data;
              cityAdminApiRes.forEach((item) => {
                if (item.access_level === "location_admin" || "admin") {
                  cityAdminTempArr.push(item);
                }
              })
              this.setState({ cityAdminData: cityAdminTempArr })
            }
            if(presentationData.length !== 0){
              presentationData.forEach((item,index)=>{
                if(item.length !== 0){
                presentationTempArr.push({
                  entity_uuid:item.entity_uuid,
                  value:index,
                  label:item.entity_name
                })
                }
                if(index === 0){
                  selectedTempArr.push({label:item.entity_name})
                }
              })
            }
            this.setState({presentationDataArr:presentationTempArr})
            this.setState({selectedData:selectedTempArr})
          })


        if (cityDataApiRes.data) {
          let resData = cityDataApiRes.data;
					this.locationInfo = resData
					console.log("THIS MY RESDATA", resData)
          this.setState({ location_uuid: resData.entity_uuid })
          let savedTempArr = [];let payloadData=[];
          if (resData && resData.image_urls) {
            resData.image_urls.forEach(async(item, index) => {
              if(index < 8){
              savedTempArr.push({ source: item, name: item.split('/').pop() })
              payloadData.push(item)
              // let image_upload_reordering = await axios.patch(`${location_api}/${resData.entity_uuid}`,{"image_urls":payloadData}, myHeaders_Autorized);
              }
            })            
            this.setState({ savedMultiImages: savedTempArr,addionalPatchImages: payloadData})
          }
          let volume_count = 0;
          if (resData.volume_count) {
            volume_count = resData.volume_count;
          }
          this.setState({
            volume_count,
            cityEntityId: resData.entity_uuid,
            cityImg: resData.city_skyline_wide_image_url,
            twitter: resData.twitter_handle,
            facebook: resData.facebook_handle,
            instagram: resData.instagram_handle,
            cityDescription: resData['description'],
            loading: false
          })
        }
      });
  }
  // select search presentation
  handleChangeFeaturedPk = (selectedOption) => {
    const { match: { params: { friendly_url } = {} } = {} } = this.props;
    const { cityEntityId, presentationDataArr, location_uuid } = this.state;
    let presentations = []; let selectedTempArr = [];
    presentationDataArr.forEach(async (item) => {
      if (selectedOption === item) {
        selectedTempArr.push(item)
        presentations.push({
          "entity_uuid": item.entity_uuid,
          "xref_data": {
            "spotlighted_time": get_current_unix_stamp()
          }
        })
        const payload = { presentations };
        //let presentation_patch_data = await axios.patch(`${location_api}/${cityEntityId}`, payload);
        await axios.patch(`${location_api}/${cityEntityId}`, payload);
        //let [selectedPres,dummy] = await Promise.all([
        await Promise.all([
          //axios.get(`${apiUrl}locations/${location_uuid}/presentations?sort[spotlighted_time]=desc&limit=1`, myHeaders_With_Cache_Control),
          axios.get(`${apiUrl}locations/${location_uuid}/presentations?sort_obj=${encodeURIComponent('{"spotlighted_time":"desc"}')}&limit=1`, myHeaders_With_Cache_Control),
          //axios.get(`${apiUrl}locations/${friendly_url}/presentations?sort[spotlighted_time]=desc&limit=1`, myHeaders_With_Cache_Control) // to break cache on actual city page
          axios.get(`${apiUrl}locations/${friendly_url}/presentations?sort_obj=${encodeURIComponent('{"spotlighted_time":"desc"}')}&limit=1`, myHeaders_With_Cache_Control) // to break cache on actual city page
        ]);          
      }

    });
    this.setState({ selectedData: selectedTempArr })
  }
  // getChangedImg will facebook_get_access_token_api 
  getChangedImg = (imgData) => {
    this.setState({ receivedImg: imgData })
  }

  // getChangedSocialLinks will facebook_get_access_token_api 
  getChangedSocialLinks = (SocialLinksData) => {
    // JBB - 3/11/2020 this is not good code. Trying to improve.
    console.log("getChangedSocialLinks",SocialLinksData);
    if (SocialLinksData.status === 1) {
      this.setState({ twitter: SocialLinksData.value });
    } else if (SocialLinksData.status === 2) {
      this.setState({ facebook: SocialLinksData.value });
    } else if (SocialLinksData.status === 3) {
      this.setState({ instagram: SocialLinksData.value })
    }
    //return (SocialLinksData.status === 1) ? this.setState({ twitter: SocialLinksData.value }) : (SocialLinksData.status === 2) ? this.setState({ facebook: SocialLinksData.value }) : this.setState({ instagram: SocialLinksData.value })
  }

  uploadAdditionalPic = async (image_obj) => {
      if (image_obj && !image_obj.file) {
          return image_obj.source;
      }
      if (image_obj && image_obj.file) {
          let coverPicPromise = new Promise(resolve => {
              let reader = new FileReader();
              reader.readAsArrayBuffer(image_obj.file);
              reader.onload = () => resolve(reader.result);
          });

          var conImgName =  image_obj.name.replace(/[^A-Za-z0-9.]/g, "");
          let multi_image_upload_data = await axios.post(`${location_api}/${image_obj.entity_uuid}/getUploadSignedUrl?asset_type=images&filename=${conImgName}`, {}, myHeaders_Autorized);
          const config = { headers: { "Content-Type": multi_image_upload_data.data.content_type } };
          let uploadUrl = multi_image_upload_data.data.upload_url;
          
          var arrVal = await coverPicPromise;
          await axios.put(uploadUrl, arrVal, config);

          return multi_image_upload_data.data.asset_url;
      }
  }

  // Update city method
  updateCity = async () => {
    const { receivedImg, twitter, facebook, instagram, cityDescription, cityEntityId, multipleImagesArr } = this.state;
    //let self = this;
    this.setState({ updateCityLoader: true });
    
    // JBB - should be calling 1 patch here for all of this
    let patch_obj = {};
    if (twitter !== undefined && twitter !== null) {
      patch_obj.twitter_handle = twitter;
    }
    if (facebook !== undefined && facebook !== null) {
      patch_obj.facebook_handle = facebook;
    }
    if (instagram !== undefined && instagram !== null) {
      patch_obj.instagram_handle = instagram;
    }
    if (cityDescription !== undefined && cityDescription !== '') {
      patch_obj['description'] = cityDescription;
    }
    if (this.state.volume_count >= 0 && this.state.volume_count <= 999999999) {
      patch_obj.volume_count = this.state.volume_count;
    }

    /*
    if (twitter !== undefined && !null) {
      if (receivedImg === null) { this.setState({ updateCityLoader: true }) }
      axios.patch(`${location_api}/${cityEntityId}`, { "twitter_handle": twitter }, myHeaders_Autorized)
        .then(() => { this.setState({ updateCityLoader: false }) })
    }

    if (facebook !== undefined && !null) {
      if (receivedImg === null) { this.setState({ updateCityLoader: true }) }
      axios.patch(`${location_api}/${cityEntityId}`, { "facebook_handle": facebook }, myHeaders_Autorized)
        .then(() => { this.setState({ updateCityLoader: false }) })
    }

    if (instagram !== undefined && !null) {
      if (receivedImg === null) { this.setState({ updateCityLoader: true }) }
      axios.patch(`${location_api}/${cityEntityId}`, { "instagram_handle": instagram }, myHeaders_Autorized)
        .then(() => { this.setState({ updateCityLoader: false }) })
    }
    */
    if (Object.keys(patch_obj).length > 0) {
      await axios.patch(`${location_api}/${cityEntityId}`, patch_obj, myHeaders_Autorized);
      this.setState({ updateCityLoader: false });
    }
    
    if (receivedImg !== null) {
      // getting array buffer in profilePicPromise
      this.setState({ updateCityLoader: true })
      let coverPicPromise = new Promise(resolve => {
          let reader = new FileReader();
          reader.readAsArrayBuffer(receivedImg);
          reader.onload = () => resolve(reader.result);
      });

      var conImgName =  receivedImg.name.replace(/[^A-Za-z0-9.]/g, "");
      let skyline_image_upload_data = await axios.post(`${location_api}/${cityEntityId}/getUploadSignedUrl?asset_type=city_skyline_wide_image&filename=${conImgName}`, {}, myHeaders_Autorized);
      const config = { headers: { "Content-Type": skyline_image_upload_data.data.content_type } };
      let uploadUrl = skyline_image_upload_data.data.upload_url;
      
      var arrVal = await coverPicPromise;
      await axios.put(uploadUrl, arrVal, config)
    }
    
    // Upload Additional Background Images Logic
    let updateImgArrays = [];
    if (multipleImagesArr.length > 0) {
      let uploadAdditionalPic_promises = [];
      for (let i = 0; i < multipleImagesArr.length; i++) {
          multipleImagesArr[i].entity_uuid = cityEntityId;
          uploadAdditionalPic_promises.push(this.uploadAdditionalPic(multipleImagesArr[i]));
      }
      updateImgArrays = await Promise.all(uploadAdditionalPic_promises);
    }
    await axios.patch(`${location_api}/${cityEntityId}`, { "image_urls": updateImgArrays }, myHeaders_Autorized);
    window.location.reload();
  }

  // Addition Background images functionality and APi Callings
  onChangeImages = async (multipleImages) => {
    multipleImages = multipleImages.sort((a, b) => a.name.localeCompare(b.name));
    if (multipleImages.length > max_additional_images) {
      multipleImages.length = max_additional_images;
    }
    this.setState({multipleImagesArr:multipleImages})
  };

  // this is in MultipleImagesUpload component now
  /*
  customRequest = ({ uid, loaded, file, onProgress }) => {
    // alert("2")
    const onUploadProgress = () => {
      onProgress(uid, Math.round(loaded / file * 10));
    }
    onUploadProgress();

    return {
      abort() {
      }
    }
  }
  */

    myChangeHandler = (event) => {
      this.setState({ [event.target.id]: event.target.value });
        //if (event.target.id === "validationDescription") {
        //    this.setState({ cityDescription: event.target.value });
        //}
    }
    

  render() {
    const { updateCityLoader, cityEntityId, cityImg, twitter, facebook, instagram, 
      //cityAdminData, loading, savedMultiImages, multipleImagesArr,presentationDataArr,selectedData } = this.state;
      cityAdminData, loading, savedMultiImages, presentationDataArr } = this.state;
      if (loading) {
      return (
        <div className="createEventSpinner">
          <ActivityIndicator theme="spinner" />
        </div>
      )
    }
    else {
      return (
        <div className="city-info">
          <div className="container pad-bot30">
            <Row className="pad-top70 pad-bot30 editCity">
              <Col lg={6} md={6} sm={6} className="pad0" >
                <h1>City Info <span><ShareAccessModalButton entity_info={{...this.locationInfo, entity_type:'locations'}} />
								</span></h1>
								
              </Col>
              <Col lg={6} md={6} sm={6} className="pad0" >
                <div className="cityUpdate-btn">
                  <NavLink to={`${local_routes.cities}/${friendly_url}`}>
                    <Button theme="btn-global btn-hover btn-cancel ">Cancel</Button>
                  </NavLink>
                  {
                    updateCityLoader === false ?
                      <Button OnClickMet={this.updateCity} theme="btn-global btn-hover btn-green btn-update">Update City</Button>
                      :
                      <ActivityIndicator theme="button-Status-Loader" />
                  }
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12} className="pad0" >
                <Form.Group controlId="cityDescription">
                  <Form.Label>DESCRIPTION</Form.Label>
                  <Form.Control
                    as="textarea"
                    value={this.state.cityDescription}
                    onChange={this.myChangeHandler}
                    placeholder="Write 2-4 sentences that describe your City."
                    rows="6"
                    //required
                  />
                </Form.Group>
              </Col>
            </Row>
             <Row>
              <Col lg={12} className="pad0" >
                <Form.Group controlId="volume_count">
                  <Form.Label>CURRENT VOLUME COUNT (Last Created PK 'Night' Event Volume Number)</Form.Label>
                  <Form.Control
                    required
                    type="number"
                    min="0"
                    max="999999999"
                    value={this.state.volume_count}
                    onChange={this.myChangeHandler}
                    placeholder="Last PK 'Night' Volume"
                    isInvalid={this.state.volume_count < 0 || this.state.volume_count > 999999999}
                  />
                  <Form.Control.Feedback type="invalid">
                      Invalid Volume
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg={12} className="coverphoto pad0 mb-4">
                <div className="pad-tb30 cover-border">
                    <h3>Featured PK</h3>
                    <p>Please select one Featured PK to show in spotlighted section of city page.</p>
                </div>
                <Row>
                  <Col md={7}>
                    <div className="presentation-multi-select mb-3">
                      <Select
                        closeMenuOnSelect={true}
                        // defaultValue={receivedProps ? apiCategories : selected}
                        // defaultValue={[presentationDataArr[1]]}
                        //value={selectedValues.length > 0 ? selectedValues : selected}
                        value={this.state.selectedData}
                        onChange={this.handleChangeFeaturedPk}
                        options={presentationDataArr}
                        isMulti={false}
                        />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="cover-photo">
              <CoverPhoto
                cityEntityId={cityEntityId}
                cityImg={cityImg}
                changedImg={this.getChangedImg}
                currentImageText={"CURRENT PRIMARY BACKGROUND IMAGE"}
                replaceImageBtn={"Replace Primary Background Image"}
                coverHead="Primary Background Image"
                coverDescription="Displayed at the top of each city page. Uploaded image will automatically be cropped and displayed with a gradient over the left side."
                coverImage={CityImage}
              />
            </Row>
            <Row className="cover-photo">
              <MultipleImagesUpload
                //customRequest={this.customRequest}
                onChangeImages={this.onChangeImages}
                //imageValidator={imageValidator}
                savedMultiImages={savedMultiImages}
                uploadErrorMessage={this.uploadErrorMessage} />
            </Row>
            <Row>
              <SocialMedia
                twitter={twitter}
                facebook={facebook}
                instagram={instagram}
                changedSocialLinks={this.getChangedSocialLinks}
                mediaHeading="Social Media Links"
                mediaSubHead="Link to social media accounts associated with this city."
              />
            </Row>
            {/* <Row>
              <CityAdmin
                adminHead="City Admins"
                adminSubHead="Accounts with admin access to this city."
                //adminDetails={adminDetails}
                cityAdminData={cityAdminData}
              />
            </Row> */}
            <Row className="d-flex justify-center">
              <div className="cityUpdate-btn">
                <NavLink to={`${local_routes.cities}/${friendly_url}`}>
                  <Button theme="btn-global btn-hover btn-cancel ">Cancel</Button>
                </NavLink>
                {
                  updateCityLoader === false ?
                    <Button OnClickMet={this.updateCity} theme="btn-global btn-hover btn-green btn-update">Update City</Button>
                    :
                    <ActivityIndicator theme="button-Status-Loader" />
                }
              </div>
            </Row>
          </div>
        </div>
      );
    }

  }
}

export default CityInfo;
